import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {Tenant} from "../../shared/models/tenant.model";

@Injectable({
  providedIn: 'root'
})
export class BulkUploadService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  runBulkUpload(tenant: Tenant, file: any){
    let form = new FormData()
    form.append('file', file?.files[0])
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `bulkUpload/bulkUpload/${tenant.tenantId}`,
      form,
      {
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    )
  }

  runBulkUploadLibrary(file: any){
    let form = new FormData()
    form.append('blob', file.files[0])
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `bulkUpload/bulkUploadLibrary`,
      form,
      {
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    )
  }

}
